var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullSubjectProgramImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99999C0 3.58172 3.58172 0 8 0H31.04C35.4583 0 39.04 3.58172 39.04 8V30.4C39.04 34.8183 35.4583 38.4 31.04 38.4H7.99999C3.58172 38.4 0 34.8183 0 30.4V7.99999Z",
    fill: "#EBF2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6263 9.70928C18.5374 9.95322 18.4895 10.2124 18.4895 10.481C18.4895 10.9626 18.9509 11.3529 19.52 11.3529H25.7027C26.2718 11.3529 26.7332 10.9626 26.7332 10.481C26.7332 10.2124 26.6853 9.95322 26.5964 9.70928M18.6263 9.70928C19.0154 8.64132 20.1911 7.86523 21.5809 7.86523H23.6418C25.0317 7.86523 26.2073 8.64132 26.5964 9.70928M18.6263 9.70928C18.1101 9.73531 17.5956 9.76637 17.0827 9.80238C15.5287 9.91153 14.3677 11.0312 14.3677 12.3507V14.8406M26.5964 9.70928C27.1126 9.73531 27.6271 9.76637 28.14 9.80238C29.694 9.91153 30.855 11.0312 30.855 12.3507V24.4318C30.855 25.8764 29.4709 27.0475 27.7636 27.0475H24.6723M14.3677 14.8406H9.73068C8.87702 14.8406 8.185 15.4262 8.185 16.1485V29.2274C8.185 29.9497 8.87702 30.5352 9.73068 30.5352H23.1266C23.9802 30.5352 24.6723 29.9497 24.6723 29.2274V27.0475M14.3677 14.8406H23.1266C23.9802 14.8406 24.6723 15.4262 24.6723 16.1485V27.0475M13.3373 23.5598L15.3982 25.3037L19.52 20.9441",
    stroke: "#0069CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullSubjectProgramImage);
export default __webpack_public_path__ + "static/media/full-subject-program-image.fbc043063d2a7c262e00b63a14c5af50.svg";
export { ForwardRef as ReactComponent };